import parse, { domToReact, Element } from 'html-react-parser'

export const replaceUrls = (content: string, urls: any) => {
  const { installerUrl, supportUrl } = urls

  return parse(content, {
    replace: (domNode) => {
      if (domNode instanceof Element && domNode.attribs) {
        if (domNode.attribs.id === 'installer') {
          return <a href={installerUrl}>{domToReact(domNode.children)}</a>
        }

        if (domNode.attribs.id === 'support') {
          return (
            <a href={supportUrl} target="_blank" rel="noreferrer">
              {domToReact(domNode.children)}
            </a>
          )
        }
      }
    },
  })
}

export const replaceSpan = (content: string, id: string, value: string) => {
  return parse(content, {
    replace: (domNode) => {
      if (domNode instanceof Element && domNode.attribs) {
        if (domNode.attribs.id === id) {
          return <span>{value}</span>
        }
      }
    },
  })
}
